import  api, { globalErrorHandler } from "../Api"

export const GET_CALENDAR_ACTIVITIES = "GET_CALENDAR_ACTIVITIES";
export const DELETE_CALENDAR_ACTIVITIE = "DELETE_CALENDAR_ACTIVITIE";
export const ADD_CALENDAR_ACTIVITIE = "ADD_CALENDAR_ACTIVITIE";
export const UPDATE_CALENDAR_ACTIVITIE = "UPDATE_CALENDAR_ACTIVITIE";
export const GET_CALENDAR_ACTIVITIES_BYID = "GET_CALENDAR_ACTIVITIES_BYID";
export const CAL_LOADING = "CAL_LOADING";
export const CAL_ERROR = "CAL_ERROR";

const config = {
  headers: {
      'content-type': 'application/json',
  }
};

export const GetCalendarActivities = (applicationId) => {
  
  return async dispatch => {
    dispatch({
      type: CAL_LOADING
    });
    await api.get(`/CalendarActivitie/GetAllByApplicationId/${applicationId}`,config).then(res => 
      dispatch({
        type: GET_CALENDAR_ACTIVITIES,
        data: res.data
        })
      ).catch(globalErrorHandler); 
  };
};

export const GetCalendarActivitiesById = (id) => {
  const config = {
      headers: {
          'content-type': 'application/json',
      }
    }  
  return async dispatch => {
    dispatch({
      type: CAL_LOADING
    });
    await api.get(`/CalendarActivitie/${id}`,config).then(res => {
      dispatch({
        type: GET_CALENDAR_ACTIVITIES_BYID,
        data: res.data
      });

      //console.log("categoriesaction", res.data)
    })
    .catch((error) => {
      globalErrorHandler(error);
      dispatch({
        type: CAL_ERROR 
      })
    });
  };
};

export const AddCalendarActivitie = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: CAL_LOADING
      });

      api.post(`/CalendarActivitie`, 
      payload, config).then(res => {
          dispatch({
              type: ADD_CALENDAR_ACTIVITIE,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: CAL_ERROR 
        })
      });
  };
};

export const UpdateCalendarActivitie = (payload) => {
  //console.log("addver", payload, files)
  return async dispatch => {
      dispatch({
          type: CAL_LOADING
      });

      api.put(`/CalendarActivitie`, 
      payload, config).then(res => {
          dispatch({
              type: UPDATE_CALENDAR_ACTIVITIE,
              payload: res.data
          });
          //console.log(res.data)
          // history.push(`/Benefits/FormAdminBenefits/${res.data}`);
      })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: CAL_ERROR 
        })
      });
  };
};

export const DeleteCalendarActivitie = (id) => dispatch => {
  dispatch({
      type: CAL_LOADING
  });
  
  api.delete(`/CalendarActivitie/Delete/${id}`).then(res => {
      dispatch({
          type: DELETE_CALENDAR_ACTIVITIE,
          payload: res.data
      });
  })
  .catch((error) => {
    globalErrorHandler(error);
    dispatch({
      type: CAL_ERROR
    })
  });
};
